import { Formik, Form } from "formik";
import { useMenu, useInstantSearch } from "react-instantsearch-hooks";

import { useThemeProps, useUniqueId } from "../../wsui/base";
import { normalizeOptions, FormToggleButtonGroupField } from "../../wsui/form";

export default function MenuButtonGroup(props) {
  props = useThemeProps({ name: "AlgoliaMenuButtonGroup", props });
  let { attribute, options, id, emptyOption, buttonProps, ...restProps } =
    props;
  const {
    items,
    // createURL,
    refine,
    // canRefine,
    // isShowingMore,
    // toggleShowMore,
    // canToggleShowMore,
    // sendEvent,
  } = useMenu(props);
  const { results, status } = useInstantSearch();
  const isLoading = status === "loading" || status === "stalled";

  let forwardedOptions;

  id = useUniqueId(id, "search-menu-button-group");

  if (options) {
    forwardedOptions = normalizeOptions(options, { emptyOption }).map(
      (item) => {
        let {
          value,
          label,
          count,
          // isRefined,
        } = { ...items.find((i) => i.value === item.value), ...item };
        if (value === "") {
          count =
            count ??
            (items.length
              ? items.reduce((sum, item) => sum + item.count, 0)
              : undefined);
        }
        return {
          value,
          label: typeof label === "function" ? label(item, items) : label,
          count: typeof count === "function" ? count(item, items) : count,
        };
      },
    );
  } else {
    forwardedOptions = items;
  }

  forwardedOptions = forwardedOptions.map(
    ({
      value,
      label,
      count,
      // isRefined,
    }) => {
      const numericCount = Number(count);
      const hasNumericCount = !Number.isNaN(numericCount);
      return {
        value,
        label: `${label} (${
          hasNumericCount ? numericCount : isLoading ? "..." : 0
        })`,
        disabled: hasNumericCount ? numericCount === 0 : false,
      };
    },
  );

  const value = items.find((item) => item.isRefined)?.value || "";
  const name = attribute.replace(/\./g, "_");

  if (!results || results.intercepted) {
    return null;
  }

  return (
    <Formik
      initialValues={{ [name]: value }}
      onSubmit={async (values) => {
        if (value !== values[name]) {
          refine(values[name] || "");
        }
      }}
    >
      {({ submitForm }) => (
        <Form>
          <FormToggleButtonGroupField
            id={id}
            options={forwardedOptions}
            name={name}
            buttonProps={{
              onMouseUp: () => {
                setTimeout(submitForm, 0);
              },
              ...buttonProps,
            }}
            {...restProps}
          />
        </Form>
      )}
    </Formik>
  );
}
